import React, {useContext, useEffect, useState} from "react";
import Column from "@meridian/components/column";
import Footer from "../commons/Footer";
import {ScanWithCodeView, ScanWithInputView} from "dolphin-meridian-react-components";
import {ReceivePackageActions} from "./actions/ReceivePackageActions";
import {AppNavigationContext} from "../appNavigation/context/AppNavigationContext";
import {ReceivePackageContext} from "./context/ReceivePackageContext";
import {FormattedMessage, injectIntl} from "react-intl";
import {Flow, Routes} from "../utils/Routes";
import {getAlertType, updateAlert} from "../utils/utils";
import {getAlertMessage, getPrintInput} from "./utils/utils";
import packageScanImage from "../../images/ic_package_scan.png";
import Modal from "@meridian/components/modal";
import {StoreKeys} from "../utils/StoreKeys";
import {SALPrinterContext} from "../scanPrinter/context/SALPrinterContext";
import {SALPrinterActions} from "../scanPrinter/actions/SALPrinterActions";
import {callNative, NativeActions, NativeCommands} from "../utils/NativeBridge";
import {isVolumetricScanEnabled} from "../utils/StorageUtil";

const ScanPackageView = (props) => {
    const {state, dispatch} = useContext(ReceivePackageContext);
    const {statePrinter, dispatchPrinter} = useContext(SALPrinterContext);
    const {navState: {helpOptions : {open: helpOpen}},
        navActions: {setupHelp, resetNavCol, errorNavCol, closeHelp, onBackDefault}} = useContext(AppNavigationContext);

    const flow = props.match.params.flow;
    const inductLocation = props.match.params.inductLocation;
    const isPrintingEnabled = flow === Flow.PRINT;

    const [volumetricScan, setVolumetricScan] = useState(false);
    const [alert, setAlert] = useState(null);
    const [helpModalOpen, setHelpModalOpen] = useState(false);

    const clear = () => {
        setupHelp(false, {});
        updateAlert(setAlert, resetNavCol);
        dispatch({type: ReceivePackageActions.RESET_INDUCT_STATE});
    }

    const onPackageScan = (packageId) => {
        dispatch({
            type: ReceivePackageActions.INDUCT_PACKAGE,
            data: {
                dispatcher: dispatch,
                packageId: packageId,
                inductLocation: inductLocation,
                isVolumetricScan: volumetricScan,
                isPrintingEnabled: isPrintingEnabled
            }
        });
    }

    const checkScanValue = () => {
        // Page refreshed on scan from Avery and package ID sent in query param
        const moduleInitializationParams = JSON.parse(localStorage.getItem(StoreKeys.MODULE_INITIALIZATION_PARAMS));
        if (moduleInitializationParams && moduleInitializationParams.scan_value && moduleInitializationParams.scan_value !== "null") {
            onPackageScan(moduleInitializationParams.scan_value);
        }
    }

    const onChangePrinter = () => {
        props.history.push(Routes.SCAN_PRINTER_WITHOUT_PROPS + flow + "/" + inductLocation);
    }

    const onSubmitHelp = (value) => {
        setHelpModalOpen(false);
        onPackageScan(value);
    }

    const helpOptions = {
        pageTitle: props.intl.formatMessage({id: "induct.help.induct_help_options", defaultMessage: "Induct help"}),
        list: [{
            title: props.intl.formatMessage({id: "induct.help.manually_enter_package_id", defaultMessage: "Enter package ID"}),
            onClick: () => {
                closeHelp();
                setHelpModalOpen(true)
            }
        }]
    };

    // Alert for Change Printer Successful
    useEffect(() => {
        if (statePrinter.printerChangeSuccess) {
            updateAlert(setAlert, resetNavCol, errorNavCol, "success", props.intl.formatMessage(
                {id: "printer.connected_device"}
            ));
            dispatchPrinter({type: SALPrinterActions.CHANGE_PRINTER_SUCCESS_RESET});
        }
    }, [statePrinter.printerChangeSuccess]);

    useEffect(() => {
        resetNavCol();
        onBackDefault();
        setupHelp(true, helpOptions);
        checkScanValue();
        return () => clear();
    }, []);

    useEffect(() => {
        if (state.inductState.isInternetNotPresent) {
            callNative(NativeActions.PRINT, NativeCommands.PRINT_SAL, {
                "message": encodeURI("No Internet"),
                "status": "error",
                "soundType": "error",
                "printer_type": "avery",
                "input": ""
            });
        }
        else if (state.inductState.isUserNotAuthorized) {
            callNative(NativeActions.PRINT, NativeCommands.PRINT_SAL, {
                "message": encodeURI("User Not Authorized"),
                "status": "error",
                "soundType": "error",
                "printer_type": "avery",
                "input": ""
            });
        }
        else if (state.inductState.isApiError) {
            callNative(NativeActions.PRINT, NativeCommands.PRINT_SAL, {
                "message": encodeURI(props.intl.formatMessage({id: "induct_service_error"})),
                "status": "error",
                "soundType": "error",
                "printer_type": "avery",
                "input": ""
            });
        }
        else if (state.inductState.responseStatus != null) {
            const inductState = state.inductState;
            callNative(NativeActions.PRINT, NativeCommands.PRINT_SAL, {
                "message": encodeURI(getAlertMessage(props.intl, inductState.responseStatus, inductState.responseCode, inductState.itemId)),
                "status": getAlertType(inductState.responseStatus),
                "soundType": inductState.soundType,
                "printer_type": "avery",
                "input": isPrintingEnabled ? encodeURI(getPrintInput(state.inductState.salPrinterOutput)) : ""
            });
        }
    }, [state.inductState]);

    return (
        <Column height="100%" spacing="none" spacingInset="none">
            {alert}
            <Column height="100%" spacingInset="small">
                <ScanWithCodeView
                    primaryTitle={{
                        title: props.intl.formatMessage({id: "induct.scan_package"}),
                        size: "Large",
                        type: "Bold"
                    }}
                    image={packageScanImage}
                    button={isPrintingEnabled ? {
                        title: props.intl.formatMessage({id: "induct.change_printer"}),
                        onClick: onChangePrinter
                    } : null}
                    onSubmit={onPackageScan}
                    focusLock={!helpOpen && !helpModalOpen}
                    checkbox={isVolumetricScanEnabled() ? {
                        label: props.intl.formatMessage({id: "volumetric_scan"}),
                        checked: volumetricScan,
                        onChange: setVolumetricScan
                    } : null}
                />
            </Column>
            <Footer>
                <FormattedMessage id={"induct.location_inducted"} values={{"location": inductLocation}} />
            </Footer>
            <Modal
                title={props.intl.formatMessage({id: "induct"})}
                open={helpModalOpen}
                onClose={() => setHelpModalOpen(false)}
                scrollContainer="viewport"
                closeLabel="Close"
                bodySpacingInset="none">
                <ScanWithInputView
                    title={props.intl.formatMessage({id: "induct.help.induct_type_id_from_keyboard", defaultMessage: "Type the full ID from keyboard"})}
                    description={props.intl.formatMessage({id: "induct.help.manually_enter_package_id", defaultMessage: "Enter package ID"})}
                    onSubmit={onSubmitHelp}
                    checkbox={isVolumetricScanEnabled() ? {
                        label: props.intl.formatMessage({id: "volumetric_scan"}),
                        checked: volumetricScan,
                        onChange: setVolumetricScan
                    } : null}
                />
            </Modal>
        </Column>
    )
}

export default injectIntl(ScanPackageView);


// WEBPACK FOOTER //
// ./src/components/receivePackage/ScanPackageView.js